module.exports = __webpack_public_path__ + "assets/lessons/en/lesson6/pages/lesson_6_1.pdf";